import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContestantRegistration from './pages/ContestantRegistration';
import TicketPurchase from './pages/TicketPurchase';
import QueenRegistration from './pages/QueenRegistration';
import ConfirmationPage from './pages/ConfirmationPage';
import PhotoGallery from './pages/PhotoGallery';
import AdminView from './pages/AdminView';
import Layout from './components/Layout';
import { FormDataProvider } from './context/FormDataContext';

function App() {
  return (
    <FormDataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="contestant-registration" element={<ContestantRegistration />} />
            <Route path="ticket-purchase" element={<TicketPurchase />} />
            <Route path="queen-registration" element={<QueenRegistration />} />
            <Route path="confirmation/:type" element={<ConfirmationPage />} />
            <Route path="photo-gallery" element={<PhotoGallery />} />
            <Route path="admin" element={<AdminView />} />
            
            {/* Redirect route for Stripe checkout */}
            <Route 
              path="stripe-checkout-redirect" 
              element={<Navigate to={`/confirmation/ticket${window.location.search}`} replace />} 
            />
          </Route>
        </Routes>
      </Router>
    </FormDataProvider>
  );
}

export default App;